export const TABLE_SORT = {
  NAME_ASC: "name-asc",
  NAME_DESC: "name-desc",
  DATE_ASC: "date-asc",
  DATE_DESC: "date-desc",
} as const;

export const DEFAULT_TABLE_SORT = TABLE_SORT.DATE_DESC;

export const DEFAULT_TABLE_SORT_OPTIONS = [
  { value: TABLE_SORT.DATE_DESC, label: "Newest first" },
  { value: TABLE_SORT.DATE_ASC, label: "Oldest first" },
  { value: TABLE_SORT.NAME_ASC, label: "Name (A–Z)" },
  { value: TABLE_SORT.NAME_DESC, label: "Name (Z–A)" },
];

export function parseTableSort(sortKey) {
  const [field, direction] = String(sortKey || "").split("-");
  return {
    field: field || "name",
    direction: direction === "desc" ? "desc" : "asc",
  };
}

function compareSortValues(a, b) {
  if (a == null && b == null) return 0;
  if (a == null) return 1;
  if (b == null) return -1;
  if (typeof a === "number" && typeof b === "number") return a - b;
  if (a instanceof Date || b instanceof Date) {
    return new Date(a).getTime() - new Date(b).getTime();
  }
  return String(a).localeCompare(String(b), undefined, { sensitivity: "base" });
}

/** Client-side sort for tables that already have their full row list in memory. */
export function sortTableRows(rows, sortKey, accessors) {
  if (!Array.isArray(rows) || !accessors) return rows || [];

  const { field, direction } = parseTableSort(sortKey);
  const getValue = accessors[field];
  if (typeof getValue !== "function") return rows;

  const copy = [...rows];
  const dir = direction === "desc" ? -1 : 1;
  copy.sort((left, right) => compareSortValues(getValue(left), getValue(right)) * dir);
  return copy;
}
